module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-ttl sigilNotInTOC",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("CAST OF CHARACTERS")]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Florence Rubrick")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Of Mount Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Arthur Rubrick")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Her husband")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Sammy Joseph")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Wool buyer for Riven Brothers")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Alf")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Storeman at Riven Brothers")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Roderick Alleyn")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Chief Detective-Inspector, CID")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Fabian Losse")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Nephew to Arthur Rubrick")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Douglas Grace")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Nephew to Florence Rubrick")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Ursula Harme")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Her niece")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Terence Lynne")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Her secretary. Later gardener at Mount Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Mrs Aceworthy")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Housekeeper at Mount Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Markins")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Manservant at Mount Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Tommy Johns")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Working manager at Mount Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Mrs Johns")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("His wife")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Cliff Johns")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Their son")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Ben Wilson")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Wool sorter")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Jack Merrywether")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Presser")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Albert Black")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Rouseabout")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-body"
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("Percy Gould")]), _vm._v(", "), _c('i', {
    staticClass: "calibre2"
  }, [_vm._v("Shearers’ cook")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d03dcc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FrontOther01.vue
// module id = 63
// module chunks = 0